import { render, staticRenderFns } from "./proOverview.vue?vue&type=template&id=e1fc672a&"
import script from "./proOverview.vue?vue&type=script&lang=js&"
export * from "./proOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports